import { render, staticRenderFns } from "./BasePreLogin.vue?vue&type=template&id=3b9de4c6&scoped=true"
import script from "./BasePreLogin.vue?vue&type=script&lang=js"
export * from "./BasePreLogin.vue?vue&type=script&lang=js"
import style0 from "./BasePreLogin.vue?vue&type=style&index=0&id=3b9de4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9de4c6",
  null
  
)

export default component.exports